import Nullstack from 'nullstack';
export default function IconTemperaturePlus({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-temperature-plus",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M8 13.5a4 4 0 1 0 4 0v-8.5a2 2 0 0 0 -4 0v8.5"
  }), "   ", Nullstack.element("line", {
    x1: "8",
    y1: "9",
    x2: "12",
    y2: "9"
  }), "   ", Nullstack.element("line", {
    x1: "16",
    y1: "9",
    x2: "22",
    y2: "9"
  }), "   ", Nullstack.element("line", {
    x1: "19",
    y1: "6",
    x2: "19",
    y2: "12"
  }), " ");
}